import { getTheBoolean, select } from './utils'

const getInvite = state => state.invite
const selectFromInvite = select(getInvite)

export const selectInviteSending = selectFromInvite(getTheBoolean('loading'))
